import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SeoContext = createContext({ seo: null, ready: false, refresh: () => {} });

export const SeoProvider = ({ children }) => {
  const [seo, setSeo] = useState(null);
  const [ready, setReady] = useState(false);

  const refresh = async () => {
    try {
      const { data } = await api.get("/seo");
      setSeo(data);
    } catch {
      setSeo(null);
    } finally {
      setReady(true);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return <SeoContext.Provider value={{ seo, ready, refresh }}>{children}</SeoContext.Provider>;
};

export const useSeo = () => useContext(SeoContext);
